import React from 'react';
import { useTranslation } from 'react-i18next';

const Impressum = () => {
  // useTranslation ist importiert, falls du künftig i18n einsetzen möchtest.
  const { i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-cream-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-serif font-light text-charcoal mb-8">
          Impressum
        </h1>

        <div className="space-y-10 text-charcoal">
          {/* §1 Anbieterangaben */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="font-light leading-relaxed text-sm">
              Anbieter dieser Website ist&nbsp;
              <strong className="text-warm-sage">
                Sanaa Ait Balla- Business Coach
              </strong>.
            </p>
            <p className="font-light leading-relaxed text-sm mt-2">
              Anschrift:&nbsp;
              <strong className="text-warm-sage">Merkelbuckel 11 </strong>,&nbsp;
              <strong className="text-warm-sage">77815 Bühl</strong>.
            </p>
            <p className="font-light leading-relaxed text-sm mt-2">
          E‑Mail:&nbsp;
              <strong className="text-warm-sage">Contact@Mindup-coaching.de</strong>
            </p>
            <p className="font-light leading-relaxed text-sm mt-2">
              Umsatzsteuer‑Identifikationsnummer gemäß §&nbsp;27a&nbsp;Umsatzsteuergesetz:&nbsp;
              <strong className="text-warm-sage">[USt‑ID einfügen]</strong>.
            </p>
          </section>



          {/* §3 EU‑Streitschlichtung */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">
              EU‑Streitschlichtung
            </h2>
            <p className="font-light leading-relaxed text-sm">
              Die Europäische Kommission stellt eine Plattform zur Online‑Streitbeilegung (OS) bereit:
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-warm-sage underline ml-1"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E‑Mail‑Adresse finden Sie oben im Impressum.
            </p>
          </section>

          {/* §4 Verbraucherstreitbeilegung */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">
              Verbraucher­streit­beilegung / Universal­schlichtungsstelle
            </h2>
            <p className="font-light leading-relaxed text-sm">
              Wir sind weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          {/* §5 Haftung für Inhalte */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">
              Haftung für Inhalte
            </h2>
            <p className="font-light leading-relaxed text-sm">
              Als Diensteanbieter sind wir gemäß § 7 Abs.&nbsp;1 TMG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung
              der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
              diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
              möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>
          </section>

          {/* §6 Haftung für Links */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">
              Haftung für Links
            </h2>
            <p className="font-light leading-relaxed text-sm">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren
              zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten
              Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          {/* §7 Urheberrecht */}
          <section>
            <h2 className="text-2xl font-serif font-light text-warm-sage mb-4">
              Urheberrecht
            </h2>
            <p className="font-light leading-relaxed text-sm">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
              deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
              jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
              privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom
              Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Sollten Sie trotzdem auf
              eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis.
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
